<template lang="pug">
  #gallery
    header.galleryPost__header
      button.galleryPost__back(@click="$router.push('/')")
        fa(icon="home")
        span &nbsp; Home
      router-link.title.is-4(to="/gallery" style="margin: 0; padding: 0; font-weight: lighter; font-size: 1.5rem; text-transform: uppercase")
        i(style="color: #049FD9") Image Gallery
      span(style="display: inline-block; width: 8rem")

    layout-container
      div.album(v-for="album in $store.state.gallery.gallery")
        h3.album__title
          span {{ album.title }}
          button.viewAlbum(@click="$router.push('/gallery/' + album.id)") See All
        div.photos
          div.photo(@click="album.photos.length > 4 && index == 4 ? $router.push('/gallery/' + album.id) : $router.push('/gallery/' + album.id + '/' + photo.id)" :style="{ backgroundImage: `url('${photo.url}')` }" :key="photo.id" :more="album.photos.length - 4" v-for="photo, index in album.photos" :class="{'more': album.photos.length > 4 && index == 4, 'none': index > 4}")
          
</template>

<style lang="sass" scoped>
@import '../assets/style'
#gallery
  min-height: 97vh
.none
  display: none
.title
  margin: $pad 0
  color: #00b8e6
  text-shadow: 1px 1px #b3b3cc

.galleryPost__header
  max-width: 1020px
  margin-left: auto
  padding: $pad 0
  margin-right: auto
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%


.galleryPost__back
  background-color: transparent

.album__title
  padding: $pad 0.5rem
  display: flex
  align-items: center
  justify-content: space-between
  color: #00b8e6

.album
  background-color: $color-background-light
  padding: 0 1rem $pad
  border-radius: 0.5rem
  border: 1px solid $color-layout-border
  margin-bottom: 1rem
  border-right: 10px solid #00b8e6
  border-left: 10px solid #00b8e6
  
.photos
  display: flex
  flex-wrap: wrap
  flex-direction: column
  height: 10rem
  cursor: pointer

  @include to($tablet-portrait)
    margin: 0.5rem
    border: 2px solid $color-background-light

  @include from($tablet-landscape)
    height: 10vw

.photo
  flex-basis: 15vw
  max-width: 100%
  flex-grow: 1
  border: 1px solid #eeeeee

  @include to($tablet-portrait)
    border: 2px solid $color-background-light
  
  @include from($tablet-landscape)
    flex-basis: 10rem
    margin: 0.5rem
  background-size: cover
  background-position: center

.more::after
  content: '+' attr(more) ' more'
  color: white
  display: block
  display: flex
  align-items: center
  justify-content: center
  height: 100%
  width: 100%
  background-color: transparentize(black, 0.25)
  transition: 0.2s background-color
.more:hover::after
  background-color: transparentize(black, 0.1)
  
.viewAlbum
  @include to($tablet-portrait)
    display: none
  background-color: #ffffff
  border: .5px solid #00b8e6
  color: #00b8e6
.viewAlbum:hover
  color: #ffffff
  border: .5px solid #00b8e6
  background-color: #00b8e6
  
</style>


<script>
import homeNav from '@/components/homeNav'
import layoutContainer from "@/components/layoutContainer";
export default {
  components: {
    layoutContainer,
    homeNav
  },
  mounted(){
    this.$store.dispatch("loadGallery");
  }
}
</script>
